import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../controllers/ContentController/Routes';
import { usePrincipals } from '../../hooks/queries';
import { getCurrentPrincipal } from '../../lib/currentPrincipal';
import { PrimaryFeature } from '../../utils/types';
import { Button } from '../Button';
import { Heading } from '../Heading';
import { Icon } from '../Icon';

type ApiKeyManagementEmptyStateProps = {
  module: 'apiKeyGenerator' | 'api-management';
  tab: 'keyHistory' | 'keyOverview';
  hideButton?: boolean;
  onClick?: () => void;
};

export const ApiKeyManagementEmptyState: FC<
  ApiKeyManagementEmptyStateProps
> = ({ module, tab, hideButton, onClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: principals } = usePrincipals();
  const { currentPrincipal } = getCurrentPrincipal(principals);
  const portalMembersRoute = routes(currentPrincipal.slug).find(
    PrimaryFeature.PORTAL_MEMBERS,
  );

  const handleClick = () => {
    if (module === 'api-management') {
      navigate(portalMembersRoute.url);
    } else {
      if (onClick) onClick();
    }
  };

  return (
    <div className="border-grey-300 flex flex-col items-center space-y-4 rounded border p-7">
      <span className="border-grey-300 h-20 w-20">
        <Icon name="EmptyMarket" />
      </span>
      <Heading
        text={t(`features:collaboration:${module}:${tab}:noData:heading`)}
        margin={0}
        level="h3"
      />
      <p className="text-grey-600 max-w-622px mt-4 text-center">
        {t(`features:collaboration:${module}:${tab}:noData:infoTextEmptyState`)}
      </p>
      {!hideButton && (
        <Button onClick={handleClick}>
          {t(`features:collaboration:${module}:${tab}:noData:buttonText`)}
        </Button>
      )}
    </div>
  );
};
